import { render, staticRenderFns } from "./LanguageSwitcher.vue?vue&type=template&id=53326b48&"
import script from "./LanguageSwitcher.vue?vue&type=script&lang=js&"
export * from "./LanguageSwitcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports